import React from 'react';
import { ModelPerformance } from '../../services/analyticsService';

interface Props {
  models: ModelPerformance[];
}

export const ModelPerformanceTable: React.FC<Props> = ({ models }) => {
  return (
    <div className="bg-white p-4 rounded-lg border">
      <h3 className="text-lg font-semibold mb-4">Performance par modele LLM</h3>
      {models.length === 0 ? (
        <p className="text-gray-500 text-center py-4">Aucune donnee</p>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b text-left">
              <th className="pb-2">Modele</th>
              <th className="pb-2">Precision</th>
              <th className="pb-2">Docs</th>
            </tr>
          </thead>
          <tbody>
            {models.map((model, idx) => (
              <tr key={idx} className="border-b last:border-0">
                <td className="py-2">
                  <span className="font-medium">{model.model_name}</span>
                  {model.model_version && (
                    <span className="text-xs text-gray-500 ml-1">({model.model_version})</span>
                  )}
                </td>
                <td className="py-2">
                  <span className={`font-medium ${
                    model.precision > 0.9 ? 'text-green-600' :
                    model.precision > 0.7 ? 'text-yellow-600' : 'text-red-600'
                  }`}>
                    {(model.precision * 100).toFixed(1)}%
                  </span>
                </td>
                <td className="py-2">{model.documents}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
